export const hrAndRMFields = [
  "hr_company_name",
  "hr_designation",
  "hr_email_id",
  "hr_first_name",
  "hr_last_name",
  "hr_middle_name",
  "hr_mobile_no",
  "manager_best_time",
  "manager_designation",
  "manager_designation1",
  "manager_email_id",
  "manager_email_id1",
  "manager_first_name",
  "manager_first_name1",
  "manager_landline_no",
  "manager_last_name",
  "manager_last_name1",
  "manager_middle_name",
  "manager_middle_name1",
  "manager_mobile_no",
  "manager_mobile_no1",
  "manager_reason",
  "manager_reason1",
  "reporting_manager_in_company",
  "connect_with_manager",
  "reporting_manager_in_company1",
  "connect_with_manager1",
  "employed_in_company",
  "employee_code",
];

export const excludedFields = [
  "company_location_id",
  "employement_verification_start_date",
  "employment_assessment_year",
  "employment_cand_mobile_no",
  "employment_certificate_no",
  "employment_mode_of_response",
  "employment_monthly_salary",
  "employment_pan_number",
  "employment_tan_number",
  "gap_explanation",
  "manager_best_time",
  "manager_landline_no",
  "nominee_dob",
  "ssn_number",
  "tenure",
  "verify_current_employment",
  "annual_salary_currency",
];

export const instantModesFields = {
  1: "Form 16",
  2: "UAN",
  3: "Employee Validation Via OTP",
  4: "Corporate Email ID Validation",
  5: "Bank Statement Analyser",
  6: "Bank Statement through Net Banking",
};

export const form16Fields = [
  "employment_pan_number",
  "employment_tan_number",
  "employment_assessment_year",
  "employment_certificate_no",
];

export const UAN = ["uan_number"];

export const employeeValidationViaOTP = ["employment_cand_mobile_no"];

export const corporateEmailValidation = ["corporate_email_id"];

export const bankStatementAnalyser = ["employment_monthly_salary"];

export const bankStatementThroughNetBanking = [
  "employment_cand_mobile_no",
  "employment_monthly_salary",
];

export const fresherOptions = [
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

export const CurrentlyEmployedOptions = [
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

export const documentCheckboxDisabledClients = [
  213874, 219325, 219317, 223244, 246971, 251351, 253771, 261682, 206255,
  231563, 78534, 274565, 277753, 131479, 214884, 299468, 317100, 85909, 319876,
  326757, 327295, 335089, 327924, 335550, 165491, 165478, 165486, 343006,
  348052,
];

export const formInputErrorMsg = {
  requiredError: "This is a required field.",
  InvalidError: "Please provide valid input",
};

export const instantFieldsMapping = {
  1: form16Fields,
  2: UAN,
  3: employeeValidationViaOTP,
  4: corporateEmailValidation,
  5: bankStatementAnalyser,
  6: bankStatementThroughNetBanking,
};

export const numbers711 = [
  "employment_cand_mobile_no",
  "hr_mobile_no",
  "manager_mobile_no",
  "manager_mobile_no1",
];
export const alphabetsAndSpace = [
  "manager_first_name",
  "manager_first_name1",
  "manager_last_name",
  "manager_last_name1",
  "manager_middle_name",
  "manager_middle_name1",
];

export const numericOnly = ["cost_to_company"];

